var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n\t.st1{fill:#CC0636;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,73.2v158.6h36.9V102.1h88.4v-66l-20.6-9.6c-6.4-3-4.9-3-9.7-0.9L73.1,41.5c-2.1,1.1-4.2,1.9-6.5,3.1 l-50.8,25C14.5,70.2,10,71.4,10,73.2L10,73.2z M176.7,142.8v89.1h36.9v-89.1L176.7,142.8L176.7,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.7,156.5h46.4v74.8H58.7V156.5L58.7,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,156.5h49.6v74.8H116V156.5L116,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.4,30.8h73.4c8.4,0,15.2,7,15.2,15.5v74.9c0,8.5-6.8,15.5-15.2,15.5h-73.4c-8.4,0-15.2-7-15.2-15.5V46.3 C142.2,37.8,149,30.8,157.4,30.8L157.4,30.8z M162.9,38.8c-7.1,0-12.9,5.9-12.9,13.2v63.6c0,7.2,5.8,13.2,12.9,13.2h62.3 c7.1,0,12.9-5.9,12.9-13.2V52c0-7.2-5.8-13.2-12.9-13.2H162.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.2,54.7c-0.5-0.2-1.2-0.2-1.7,0.1c-0.3,0.1-3.3,3-9.4,9.2l-9,9l-9.2-9.1c-9.1-9.1-9.2-9.1-9.7-9.2 c-0.2,0-0.7,0-1,0c-0.5,0.1-0.6,0.2-4.3,3.9s-3.8,3.8-3.9,4.3c0,0.2,0,0.7,0,1c0.1,0.5,0.2,0.6,9.2,9.7l9.1,9.2l-9.1,9.2 c-9.1,9.1-9.1,9.2-9.2,9.7c0,0.2,0,0.7,0,1c0.1,0.5,0.2,0.6,3.9,4.3c3.7,3.7,3.8,3.8,4.3,3.9c0.2,0,0.7,0,1,0 c0.5-0.1,0.6-0.2,9.7-9.2l9.2-9.1l9.2,9.1c9.1,9.1,9.2,9.1,9.7,9.2c0.2,0,0.7,0,1,0c0.5-0.1,0.6-0.2,4.3-3.9 c3.7-3.7,3.8-3.8,3.9-4.3c0-0.2,0-0.7,0-1c-0.1-0.5-0.2-0.6-9.2-9.7l-9.1-9.2l9.1-9.2c9.1-9.1,9.1-9.2,9.2-9.7c0-0.2,0-0.7,0-1 c-0.1-0.5-0.2-0.6-3.7-4.2C215.4,55.7,214.5,54.8,214.2,54.7z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTerminal);
export default __webpack_public_path__ + "static/media/delete-terminal.4880b587971863108db6fb750d8e5d79.svg";
export { ForwardRef as ReactComponent };